var iconList = {
  accessibility: 'accessibility',
  'accessibility-fill': 'accessibility-fill',
  'accessibility-sign-language': 'accessibility-sign-language',
  'accessibility-sign-language-fill': 'accessibility-sign-language-fill',
  'Sign-language': 'accessibility-sign-language',
  'Sign-language-fill': 'accessibility-sign-language-fill',
  'alarm-clock': 'alarm-clock',
  'alarm-clock-fill': 'alarm-clock-fill',
  'Stop-timer': 'alarm-clock',
  'Stop-timer-fill': 'alarm-clock-fill',
  'alternative-a-small': 'alternative-a-small',
  'alternative-a-small-fill': 'alternative-a-small',
  'Alternative-A-small': 'alternative-a-small',
  'Alternative-A-small-fill': 'alternative-a-small',
  'alternative-a': 'alternative-a',
  'alternative-a-fill': 'alternative-a',
  'Alternative-A': 'alternative-a',
  'Alternative-A-fill': 'alternative-a',
  'alternative-b-small': 'alternative-b-small',
  'alternative-b-small-fill': 'alternative-b-small',
  'Alternative-B-small': 'alternative-b-small',
  'Alternative-B-small-fill': 'alternative-b-small',
  'alternative-b': 'alternative-b',
  'alternative-b-fill': 'alternative-b',
  'Alternative-B': 'alternative-b',
  'Alternative-B-fill': 'alternative-b',
  'alternative-c-small': 'alternative-c-small',
  'alternative-c-small-fill': 'alternative-c-small',
  'Alternative-C-small': 'alternative-c-small',
  'Alternative-C-small-fill': 'alternative-c-small',
  'alternative-c': 'alternative-c',
  'alternative-c-fill': 'alternative-c',
  'Alternative-C': 'alternative-c',
  'Alternative-C-fill': 'alternative-c',
  'alternative-d-small': 'alternative-d-small',
  'alternative-d-small-fill': 'alternative-d-small',
  'Alternative-D-small': 'alternative-d-small',
  'Alternative-D-small-fill': 'alternative-d-small',
  'alternative-d': 'alternative-d',
  'alternative-d-fill': 'alternative-d',
  'Alternative-D': 'alternative-d',
  'Alternative-D-fill': 'alternative-d',
  'alternative-e-small': 'alternative-e-small',
  'alternative-e-small-fill': 'alternative-e-small',
  'Alternative-E-small': 'alternative-e-small',
  'Alternative-E-small-fill': 'alternative-e-small',
  'alternative-e': 'alternative-e',
  'alternative-e-fill': 'alternative-e',
  'Alternative-E': 'alternative-e',
  'Alternative-E-fill': 'alternative-e',
  'alternative-f-small': 'alternative-f-small',
  'alternative-f-small-fill': 'alternative-f-small',
  'alternative-f': 'alternative-f',
  'alternative-f-fill': 'alternative-f',
  'alternative-g-small': 'alternative-g-small',
  'alternative-g-small-fill': 'alternative-g-small',
  'alternative-g': 'alternative-g',
  'alternative-g-fill': 'alternative-g',
  'alternative-h-small': 'alternative-h-small',
  'alternative-h-small-fill': 'alternative-h-small',
  'alternative-h': 'alternative-h',
  'alternative-h-fill': 'alternative-h',
  'alternative-i-small': 'alternative-i-small',
  'alternative-i-small-fill': 'alternative-i-small',
  'alternative-i': 'alternative-i',
  'alternative-i-fill': 'alternative-i',
  'alternative-j-small': 'alternative-j-small',
  'alternative-j-small-fill': 'alternative-j-small',
  'alternative-j': 'alternative-j',
  'alternative-j-fill': 'alternative-j',
  'alternative-k-small': 'alternative-k-small',
  'alternative-k-small-fill': 'alternative-k-small',
  'alternative-k': 'alternative-k',
  'alternative-k-fill': 'alternative-k',
  'alternative-l-small': 'alternative-l-small',
  'alternative-l-small-fill': 'alternative-l-small',
  'alternative-l': 'alternative-l',
  'alternative-l-fill': 'alternative-l',
  'alternative-m-small': 'alternative-m-small',
  'alternative-m-small-fill': 'alternative-m-small',
  'alternative-m': 'alternative-m',
  'alternative-m-fill': 'alternative-m',
  'alternative-n-small': 'alternative-n-small',
  'alternative-n-small-fill': 'alternative-n-small',
  'alternative-n': 'alternative-n',
  'alternative-n-fill': 'alternative-n',
  'alternative-o-small': 'alternative-o-small',
  'alternative-o-small-fill': 'alternative-o-small',
  'alternative-o': 'alternative-o',
  'alternative-o-fill': 'alternative-o',
  'alternative-p-small': 'alternative-p-small',
  'alternative-p-small-fill': 'alternative-p-small',
  'alternative-p': 'alternative-p',
  'alternative-p-fill': 'alternative-p',
  'alternative-q-small': 'alternative-q-small',
  'alternative-q-small-fill': 'alternative-q-small',
  'alternative-q': 'alternative-q',
  'alternative-q-fill': 'alternative-q',
  'alternative-r-small': 'alternative-r-small',
  'alternative-r-small-fill': 'alternative-r-small',
  'alternative-r': 'alternative-r',
  'alternative-r-fill': 'alternative-r',
  'alternative-s-small': 'alternative-s-small',
  'alternative-s-small-fill': 'alternative-s-small',
  'alternative-s': 'alternative-s',
  'alternative-s-fill': 'alternative-s',
  'alternative-t-small': 'alternative-t-small',
  'alternative-t-small-fill': 'alternative-t-small',
  'alternative-t': 'alternative-t',
  'alternative-t-fill': 'alternative-t',
  'alternative-u-small': 'alternative-u-small',
  'alternative-u-small-fill': 'alternative-u-small',
  'alternative-u': 'alternative-u',
  'alternative-u-fill': 'alternative-u',
  'alternative-v-small': 'alternative-v-small',
  'alternative-v-small-fill': 'alternative-v-small',
  'alternative-v': 'alternative-v',
  'alternative-v-fill': 'alternative-v',
  'alternative-w-small': 'alternative-w-small',
  'alternative-w-small-fill': 'alternative-w-small',
  'alternative-w': 'alternative-w',
  'alternative-w-fill': 'alternative-w',
  'alternative-x-small': 'alternative-x-small',
  'alternative-x-small-fill': 'alternative-x-small',
  'alternative-x': 'alternative-x',
  'alternative-x-fill': 'alternative-x',
  'alternative-y-small': 'alternative-y-small',
  'alternative-y-small-fill': 'alternative-y-small',
  'alternative-y': 'alternative-y',
  'alternative-y-fill': 'alternative-y',
  'alternative-z-small': 'alternative-z-small',
  'alternative-z-small-fill': 'alternative-z-small',
  'alternative-z': 'alternative-z',
  'alternative-z-fill': 'alternative-z',
  'arrow-down-left-curve': 'arrow-down-left-curve',
  'arrow-down-left-curve-fill': 'arrow-down-left-curve',
  'Arrow-back-up': 'arrow-down-left-curve',
  'Arrow-back-up-fill': 'arrow-down-left-curve',
  'arrow-down-left': 'arrow-down-left',
  'arrow-down-left-fill': 'arrow-down-left',
  'arrow-down-right-curve': 'arrow-down-right-curve',
  'arrow-down-right-curve-fill': 'arrow-down-right-curve',
  'Arrow-forward-up': 'arrow-down-right-curve',
  'Arrow-forward-up-fill': 'arrow-down-right-curve',
  'arrow-down-right': 'arrow-down-right',
  'arrow-down-right-fill': 'arrow-down-right',
  'arrow-down': 'arrow-down',
  'arrow-down-fill': 'arrow-down',
  'arrow-left': 'arrow-left',
  'arrow-left-fill': 'arrow-left',
  'arrow-right': 'arrow-right',
  'arrow-right-fill': 'arrow-right',
  'Arrow-tip-down': 'arrow-tip-down',
  'Arrow-tip-down-fill': 'arrow-tip-down',
  'arrow-tip-down': 'arrow-tip-down',
  'arrow-tip-down-fill': 'arrow-tip-down',
  'Arrow-tip-left': 'arrow-tip-left',
  'Arrow-tip-left-fill': 'arrow-tip-left',
  'arrow-tip-left': 'arrow-tip-left',
  'arrow-tip-left-fill': 'arrow-tip-left',
  'Arrow-tip-right': 'arrow-tip-right',
  'Arrow-tip-right-fill': 'arrow-tip-right',
  'arrow-tip-right': 'arrow-tip-right',
  'arrow-tip-right-fill': 'arrow-tip-right',
  'arrow-tip-sort-ascending': 'arrow-tip-sort-ascending',
  'arrow-tip-sort-ascending-fill': 'arrow-tip-sort-ascending',
  'arrow-tip-sort-descending': 'arrow-tip-sort-descending',
  'arrow-tip-sort-descending-fill': 'arrow-tip-sort-descending',
  'Arrow-tip-sort': 'arrow-tip-sort',
  'Arrow-tip-sort-fill': 'arrow-tip-sort',
  'arrow-tip-sort': 'arrow-tip-sort',
  'arrow-tip-sort-fill': 'arrow-tip-sort',
  'Arrow-tip-up': 'arrow-tip-up',
  'Arrow-tip-up-fill': 'arrow-tip-up',
  'arrow-tip-up': 'arrow-tip-up',
  'arrow-tip-up-fill': 'arrow-tip-up',
  'arrow-to-bottom': 'arrow-to-bottom',
  'arrow-to-bottom-fill': 'arrow-to-bottom',
  'arrow-to-top': 'arrow-to-top',
  'arrow-to-top-fill': 'arrow-to-top',
  'arrow-up-left-curve': 'arrow-up-left-curve',
  'arrow-up-left-curve-fill': 'arrow-up-left-curve',
  'Arrow-back-down': 'arrow-up-left-curve',
  'Arrow-back-down-fill': 'arrow-up-left-curve',
  'arrow-up-left': 'arrow-up-left',
  'arrow-up-left-fill': 'arrow-up-left',
  'arrow-up-right-curve': 'arrow-up-right-curve',
  'arrow-up-right-curve-fill': 'arrow-up-right-curve',
  'Arrow-forward-down': 'arrow-up-right-curve',
  'Arrow-forward-down-fill': 'arrow-up-right-curve',
  'arrow-up-right': 'arrow-up-right',
  'arrow-up-right-fill': 'arrow-up-right',
  'arrows-contract-alt': 'arrows-contract-alt',
  'arrows-contract-alt-fill': 'arrows-contract-alt',
  'arrows-contract': 'arrows-contract',
  'arrows-contract-fill': 'arrows-contract',
  'Contracting-arrows': 'arrows-contract',
  'Contracting-arrows-fill': 'arrows-contract',
  'arrows-expand-alt': 'arrows-expand-alt',
  'arrows-expand-alt-fill': 'arrows-expand-alt',
  'arrows-expand': 'arrows-expand',
  'arrows-expand-fill': 'arrows-expand',
  'Expanding-arrow': 'arrows-expand',
  'Expanding-arrow-fill': 'arrows-expand',
  'arrow-up': 'arrow-up',
  'arrow-up-fill': 'arrow-up',
  'assistant-ai': 'assistant-ai',
  'assistant-ai-fill': 'assistant-ai-fill',
  atom: 'atom',
  'atom-fill': 'atom',
  Atom: 'atom',
  'Atom-fill': 'atom',
  backpack: 'backpack',
  'backpack-fill': 'backpack-fill',
  'badge-check': 'badge-check',
  'badge-check-fill': 'badge-check-fill',
  'badge-star': 'badge-star',
  'badge-star-fill': 'badge-star-fill',
  'barcode-scan': 'barcode-scan',
  'barcode-scan-fill': 'barcode-scan',
  Scan: 'barcode-scan',
  'Scan-fill': 'barcode-scan',
  Bell: 'bell',
  'Bell-fill': 'bell-fill',
  bell: 'bell',
  'bell-fill': 'bell-fill',
  blackboard: 'blackboard',
  'blackboard-fill': 'blackboard-fill',
  Lesson: 'blackboard',
  'Lesson-fill': 'blackboard-fill',
  Book: 'book',
  'Book-fill': 'book-fill',
  book: 'book',
  'book-fill': 'book-fill',
  'book-literary': 'book-literary',
  'book-literary-fill': 'book-literary-fill',
  'Book-open': 'book-open',
  'Book-open-fill': 'book-open-fill',
  'book-open': 'book-open',
  'book-open-fill': 'book-open-fill',
  'Book-open-alt': 'book-open-alt',
  'Book-open-alt-fill': 'book-open-alt-fill',
  'book-open-alt': 'book-open-alt',
  'book-open-alt-fill': 'book-open-alt-fill',
  'book-stack': 'book-stack',
  'book-stack-fill': 'book-stack-fill',
  Library: 'book-stack',
  'Library-fill': 'book-stack-fill',
  'Book-english': 'book-subject-english',
  'Book-english-fill': 'book-subject-english-fill',
  'book-subject-english': 'book-subject-english',
  'book-subject-english-fill': 'book-subject-english-fill',
  'Book-french': 'book-subject-french',
  'Book-french-fill': 'book-subject-french-fill',
  'book-subject-french': 'book-subject-french',
  'book-subject-french-fill': 'book-subject-french-fill',
  'Book-german': 'book-subject-german',
  'Book-german-fill': 'book-subject-german-fill',
  'book-subject-german': 'book-subject-german',
  'book-subject-german-fill': 'book-subject-german-fill',
  'Book-portuguese': 'book-subject-portuguese',
  'Book-portuguese-fill': 'book-subject-portuguese-fill',
  'book-subject-portuguese': 'book-subject-portuguese',
  'book-subject-portuguese-fill': 'book-subject-portuguese-fill',
  'Book-spanish': 'book-subject-spanish',
  'Book-spanish-fill': 'book-subject-spanish-fill',
  'book-subject-spanish': 'book-subject-spanish',
  'book-subject-spanish-fill': 'book-subject-spanish-fill',
  'Bookmark-empty': 'bookmark',
  'Bookmark-empty-fill': 'bookmark-fill',
  bookmark: 'bookmark',
  Bookmark: 'bookmark-fill',
  'Bookmark-fill': 'bookmark',
  'bookmark-fill': 'bookmark-fill',
  Briefcase: 'briefcase',
  'Briefcase-fill': 'briefcase-fill',
  briefcase: 'briefcase',
  'briefcase-fill': 'briefcase-fill',
  'browser-check': 'browser-check',
  'browser-check-fill': 'browser-check-fill',
  'Local-download-done': 'browser-check',
  'Local-download-done-fill': 'browser-check-fill',
  'browser-download': 'browser-download',
  'browser-download-fill': 'browser-download-fill',
  'Local-download': 'browser-download',
  'Local-download-fill': 'browser-download-fill',
  'bubble-alt': 'bubble-alt',
  'bubble-alt-fill': 'bubble-alt',
  'Chat-bubble': 'bubble-alt',
  'Chat-bubble-fill': 'bubble-alt',
  Bubble: 'bubble',
  'Bubble-fill': 'bubble-fill',
  bubble: 'bubble',
  'bubble-fill': 'bubble-fill',
  'bullet-list': 'bullet-list',
  'bullet-list-fill': 'bullet-list',
  List: 'bullet-list',
  'List-fill': 'bullet-list',
  Bullet: 'bullet',
  'Bullet-fill': 'bullet-fill',
  bullet: 'bullet',
  'bullet-fill': 'bullet',
  calculator: 'calculator',
  'calculator-fill': 'calculator-fill',
  Calculate: 'calculator',
  'Calculate-fill': 'calculator-fill',
  calendar: 'calendar',
  'calendar-fill': 'calendar-fill',
  Calendar: 'calendar',
  'Calendar-fill': 'calendar-fill',
  camera: 'camera',
  'camera-fill': 'camera-fill',
  Camera: 'camera',
  'Camera-fill': 'camera-fill',
  'Cancel-circle': 'cancel-circle',
  'Cancel-circle-fill': 'cancel-circle-fill',
  'cancel-circle': 'cancel-circle',
  'cancel-circle-fill': 'cancel-circle-fill',
  'cancel-circle-small': 'cancel-circle-small',
  'cancel-circle-small-fill': 'cancel-circle-small-fill',
  'Cancel-circle-small': 'cancel-circle-small',
  'Cancel-circle-small-fill': 'cancel-circle-small-fill',
  'Cancel-small': 'cancel-small',
  'Cancel-small-fill': 'cancel-small',
  'cancel-small': 'cancel-small',
  'cancel-small-fill': 'cancel-small',
  Cancel: 'cancel',
  'Cancel-fill': 'cancel',
  cancel: 'cancel',
  'cancel-fill': 'cancel',
  'chart-pie': 'chart-pie',
  'chart-pie-fill': 'chart-pie-fill',
  'Graph-pizza': 'chart-pie',
  'Graph-pizza-fill': 'chart-pie-fill',
  'check-circle': 'check-circle',
  'check-circle-fill': 'check-circle-fill',
  'Check-circle': 'check-circle',
  'Check-circle-fill': 'check-circle-fill',
  'check-circle-small': 'check-circle-small',
  'check-circle-small-fill': 'check-circle-small-fill',
  'Check-circle-small': 'check-circle-small',
  'Check-circle-small-fill': 'check-circle-small-fill',
  'check-done': 'check-double',
  'check-done-fill': 'check-double',
  'check-double': 'check-double',
  'check-double-fill': 'check-double',
  'check-double-small': 'check-double-small',
  'check-double-small-fill': 'check-double-small',
  'check-small': 'check-small',
  'check-small-fill': 'check-small',
  'Check-small': 'check-small',
  'Check-small-fill': 'check-small',
  check: 'check',
  'check-fill': 'check',
  Check: 'check',
  'Check-big': 'check',
  'Check-big-fill': 'check',
  'Check-fill': 'check',
  'Chevron-down': 'chevron-down',
  'Chevron-down-fill': 'chevron-down',
  'chevron-down': 'chevron-down',
  'chevron-down-fill': 'chevron-down',
  'Chevron-left': 'chevron-left',
  'Chevron-left-fill': 'chevron-left',
  'chevron-left': 'chevron-left',
  'chevron-left-fill': 'chevron-left',
  'Chevron-right': 'chevron-right',
  'Chevron-right-fill': 'chevron-right',
  'chevron-right': 'chevron-right',
  'chevron-right-fill': 'chevron-right',
  'Chevron-up': 'chevron-up',
  'Chevron-up-fill': 'chevron-up',
  'chevron-up': 'chevron-up',
  'chevron-up-fill': 'chevron-up',
  clip: 'clip',
  'clip-fill': 'clip',
  Clip: 'clip',
  'Clip-fill': 'clip',
  clock: 'clock',
  'clock-fill': 'clock-fill',
  Clock: 'clock',
  'Clock-fill': 'clock-fill',
  'clock-loading-back': 'clock-loading-back',
  'clock-loading-back-fill': 'clock-loading-back',
  collection: 'collection',
  'collection-fill': 'collection-fill',
  Collection: 'collection',
  'Collection-fill': 'collection-fill',
  'color-palette': 'color-palette',
  'color-palette-fill': 'color-palette-fill',
  Palette: 'color-palette',
  'Palette-fill': 'color-palette-fill',
  columns: 'columns-medium',
  'columns-fill': 'columns-medium-fill',
  'columns-large': 'columns-large',
  'columns-large-fill': 'columns-large-fill',
  'columns-medium': 'columns-medium',
  'columns-medium-fill': 'columns-medium-fill',
  'columns-small': 'columns-small',
  'columns-small-fill': 'columns-small-fill',
  'columns-alt': 'columns-alt',
  'columns-alt-fill': 'columns-alt',
  'control-next-circle': 'control-next-circle',
  'control-next-circle-fill': 'control-next-circle-fill',
  'control-next-square': 'control-next-square',
  'control-next-square-fill': 'control-next-square-fill',
  'control-pause-circle': 'control-pause-circle',
  'control-pause-circle-fill': 'control-pause-circle-fill',
  'control-pause-square': 'control-pause-square',
  'control-pause-square-fill': 'control-pause-square-fill',
  'control-play-circle': 'control-play-circle',
  'control-play-circle-fill': 'control-play-circle-fill',
  'control-play-square': 'control-play-square',
  'control-play-square-fill': 'control-play-square-fill',
  'control-previous-circle': 'control-previous-circle',
  'control-previous-circle-fill': 'control-previous-circle-fill',
  'control-previous-square': 'control-previous-square',
  'control-previous-square-fill': 'control-previous-square-fill',
  'control-stop-circle': 'control-stop-circle',
  'control-stop-circle-fill': 'control-stop-circle-fill',
  'control-stop-square': 'control-stop-square',
  'control-stop-square-fill': 'control-stop-square-fill',
  copy: 'copy',
  'copy-fill': 'copy-fill',
  Copy: 'copy',
  'Copy-fill': 'copy-fill',
  'credit-card': 'credit-card',
  'credit-card-fill': 'credit-card-fill',
  'Credit-card': 'credit-card',
  'Credit-card-fill': 'credit-card-fill',
  'currency-real': 'currency-real',
  'currency-real-fill': 'currency-real-fill',
  Currency: 'currency-real',
  'Currency-fill': 'currency-real-fill',
  cycle: 'cycle',
  'cycle-fill': 'cycle-fill',
  CGE: 'cycle',
  'CGE-fill': 'cycle-fill',
  density: 'density',
  'density-fill': 'density',
  'device-computer': 'device-computer',
  'device-computer-fill': 'device-computer-fill',
  Desktop: 'device-computer',
  'Desktop-fill': 'device-computer-fill',
  'device-mobile': 'device-mobile',
  'device-mobile-fill': 'device-mobile-fill',
  'device-notebook-chat': 'device-notebook-chat',
  'device-notebook-chat-fill': 'device-notebook-chat-fill',
  'device-notebook': 'device-notebook',
  'device-notebook-fill': 'device-notebook-fill',
  'device-tablet': 'device-tablet',
  'device-tablet-fill': 'device-tablet-fill',
  dna: 'dna',
  'dna-fill': 'dna',
  DNA: 'dna',
  'DNA-fill': 'dna',
  'document-alt': 'document-alt',
  'document-alt-fill': 'document-alt-fill',
  'document-check-alt': 'document-check-alt',
  'document-check-alt-fill': 'document-check-alt-fill',
  'Exam-alt': 'document-check-alt',
  'Exam-alt-fill': 'document-check-alt-fill',
  'document-check': 'document-check',
  'document-check-fill': 'document-check-fill',
  'document-double-page': 'document-double-page',
  'document-double-page-fill': 'document-double-page-fill',
  Exam: 'document-check',
  'Exam-fill': 'document-check-fill',
  'document-file-doc': 'document-file-doc',
  'document-file-doc-fill': 'document-file-doc',
  'document-doc': 'document-file-doc',
  'document-doc-fill': 'document-file-doc',
  'Document-doc': 'document-file-doc',
  'Document-doc-fill': 'document-file-doc',
  'document-file-pdf': 'document-file-pdf',
  'document-file-pdf-fill': 'document-file-pdf',
  'document-pdf': 'document-file-pdf',
  'document-pdf-fill': 'document-file-pdf',
  'Document-pdf': 'document-file-pdf',
  'Document-pdf-fill': 'document-file-pdf',
  'document-file-ppt': 'document-file-ppt',
  'document-file-ppt-fill': 'document-file-ppt',
  'Document-ppt': 'document-file-ppt',
  'Document-ppt-fill': 'document-file-ppt',
  'document-ppt': 'document-file-ppt',
  'document-ppt-fill': 'document-file-ppt',
  'document-file-xls': 'document-file-xls',
  'document-file-xls-fill': 'document-file-xls',
  'document-xls': 'document-file-xls',
  'document-xls-fill': 'document-file-xls',
  'Document-xls': 'document-file-xls',
  'Document-xls-fill': 'document-file-xls',
  'document-txt': 'document-file-txt',
  'document-txt-fill': 'document-file-txt',
  'Document-txt': 'document-file-txt',
  'Document-txt-fill': 'document-file-txt',
  document: 'document',
  'document-fill': 'document-fill',
  Document: 'document',
  'Document-fill': 'document-fill',
  'document-sequential-page': 'document-sequential-page',
  'document-sequential-page-fill': 'document-sequential-page-fill',
  'document-sheet': 'document-sheet',
  'document-sheet-fill': 'document-sheet-fill',
  'Document-Sheet': 'document-sheet',
  'Document-Sheet-fill': 'document-sheet-fill',
  'document-text-alt': 'document-text-alt',
  'document-text-alt-fill': 'document-text-alt-fill',
  'document-text': 'document-text',
  'document-text-fill': 'document-text-fill',
  'Document-Text': 'document-text',
  'Document-Text-fill': 'document-text-fill',
  'Document-text': 'document-text',
  'Document-text-fill': 'document-text-fill',
  'download-alt': 'download-alt',
  'download-alt-fill': 'download-alt-fill',
  'Download-alt': 'download-alt-fill',
  'Download-alt-fill': 'download-alt',
  'Download-empty-alt': 'download-alt',
  'Download-empty-alt-fill': 'download-alt-fill',
  'download-from-cloud': 'download-from-cloud',
  'download-from-cloud-fill': 'download-from-cloud',
  'Download-from-cloud-alt': 'download-from-cloud',
  'Download-from-cloud-alt-fill': 'download-from-cloud',
  download: 'download',
  'download-fill': 'download',
  Download: 'download',
  'Download-fill': 'download',
  'drag-dots-horizontal': 'drag-dots-horizontal',
  'drag-dots-horizontal-fill': 'drag-dots-horizontal',
  'drag-dots-vertical': 'drag-dots-vertical',
  'drag-dots-vertical-fill': 'drag-dots-vertical',
  'drag-lines': 'drag-lines',
  'drag-lines-fill': 'drag-lines',
  edit: 'edit',
  'edit-fill': 'edit-fill',
  'Edit-note': 'edit',
  'Edit-note-fill': 'edit-fill',
  'edit-note': 'edit-note',
  'edit-note-fill': 'edit-note-fill',
  Notes: 'edit-note',
  'Notes-fill': 'edit-note-fill',
  email: 'email',
  'email-fill': 'email-fill',
  Email: 'email',
  'Email-fill': 'email-fill',
  eye: 'eye',
  'eye-fill': 'eye-fill',
  Eye: 'eye',
  'Eye-fill': 'eye-fill',
  'eye-hide': 'eye-hide',
  'eye-hide-fill': 'eye-hide-fill',
  'eye-target': 'eye-target',
  'eye-target-fill': 'eye-target-fill',
  'Eye-closed': 'eye-hide',
  'Eye-closed-fill': 'eye-hide-fill',
  Dislike: 'face-dislike-circle',
  'Dislike-fill': 'face-dislike-circle-fill',
  'face-dislike-circle': 'face-dislike-circle',
  'face-dislike-circle-fill': 'face-dislike-circle-fill',
  'face-dislike-square': 'face-dislike-square',
  'face-dislike-square-fill': 'face-dislike-square-fill',
  Hate: 'face-hate-circle',
  'Hate-fill': 'face-hate-circle-fill',
  'face-hate-circle': 'face-hate-circle',
  'face-hate-circle-fill': 'face-hate-circle-fill',
  'face-hate-square': 'face-hate-square',
  'face-hate-square-fill': 'face-hate-square-fill',
  Like: 'face-like-circle',
  'Like-fill': 'face-like-circle-fill',
  'face-like-circle': 'face-like-circle',
  'face-like-circle-fill': 'face-like-circle-fill',
  'face-like-square': 'face-like-square',
  'face-like-square-fill': 'face-like-square-fill',
  Love: 'face-love-circle',
  'Love-fill': 'face-love-circle-fill',
  'face-love-circle': 'face-love-circle',
  'face-love-circle-fill': 'face-love-circle-fill',
  'face-love-square': 'face-love-square',
  'face-love-square-fill': 'face-love-square-fill',
  Neutral: 'face-neutral-circle',
  'Neutral-fill': 'face-neutral-circle-fill',
  'face-neutral-circle': 'face-neutral-circle',
  'face-neutral-circle-fill': 'face-neutral-circle-fill',
  'face-neutral-square': 'face-neutral-square',
  'face-neutral-square-fill': 'face-neutral-square-fill',
  'filter-sort': 'filter-sort',
  'filter-sort-fill': 'filter-sort',
  filter: 'filter',
  'filter-fill': 'filter',
  Filter: 'filter',
  'Filter-fill': 'filter',
  flag: 'flag',
  'flag-fill': 'flag-fill',
  folder: 'folder',
  'folder-fill': 'folder-fill',
  Folder: 'folder',
  'Folder-fill': 'folder-fill',
  'folder-maximize': 'folder-maximize',
  'folder-maximize-fill': 'folder-maximize-fill',
  'Folder-expandable': 'folder-maximize',
  'Folder-expandable-fill': 'folder-maximize-fill',
  'folder-minimize': 'folder-minimize',
  'folder-minimize-fill': 'folder-minimize-fill',
  'Folder-colapsable': 'folder-minimize',
  'Folder-colapsable-fill': 'folder-minimize-fill',
  'folder-open': 'folder-open',
  'folder-open-fill': 'folder-open-fill',
  'Folder-opened': 'folder-open',
  'Folder-opened-fill': 'folder-open-fill',
  'globe-arrow': 'globe-arrow',
  'globe-arrow-fill': 'globe-arrow-fill',
  globe: 'globe',
  'globe-fill': 'globe',
  Globe: 'globe',
  'Globe-fill': 'globe',
  'greek-column': 'greek-column',
  'greek-column-fill': 'greek-column-fill',
  'Greek-column': 'greek-column',
  'Greek-column-fill': 'greek-column-fill',
  'grid-dots': 'grid-dots',
  'grid-dots-fill': 'grid-dots',
  Apps: 'grid-dots',
  'Apps-fill': 'grid-dots',
  'grid-lines': 'grid-lines',
  'grid-lines-fill': 'grid-lines',
  'grid-rectangles-horizontal': 'grid-rectangles-horizontal',
  'grid-rectangles-horizontal-fill': 'grid-rectangles-horizontal',
  'grid-rectangles-vertical': 'grid-rectangles-vertical',
  'grid-rectangles-vertical-fill': 'grid-rectangles-vertical',
  'grid-squares': 'grid-squares',
  'grid-squares-fill': 'grid-squares',
  hand: 'hand',
  'hand-fill': 'hand-fill',
  'Raised-hand': 'hand',
  'Raised-hand-fill': 'hand-fill',
  'hand-pray': 'hand-pray',
  'hand-pray-fill': 'hand-pray-fill',
  'Hand-pray': 'hand-pray',
  'Hand-pray-fill': 'hand-pray-fill',
  handshake: 'hand-shake',
  'handshake-fill': 'hand-shake-fill',
  Handshake: 'hand-shake',
  'Handshake-fill': 'hand-shake-fill',
  'head-mind': 'head-mind',
  'head-mind-fill': 'head-mind-fill',
  Mind: 'head-mind',
  'Mind-fill': 'head-mind-fill',
  headset: 'headset',
  'headset-fill': 'headset-fill',
  Headset: 'headset',
  'Headset-fill': 'headset-fill',
  'heart-broken': 'heart-broken',
  'heart-broken-fill': 'heart-broken-fill',
  'Heart-broken': 'heart-broken',
  'Heart-broken-fill': 'heart-broken-fill',
  heart: 'heart',
  'heart-fill': 'heart-fill',
  Heart: 'heart-fill',
  'Heart-empty': 'heart',
  hierarchy: 'hierarchy',
  'hierarchy-fill': 'hierarchy-fill',
  SGA: 'hierarchy',
  'SGA-fill': 'hierarchy-fill',
  home: 'home',
  'home-fill': 'home-fill',
  Home: 'home',
  'Home-fill': 'home-fill',
  'house-heart': 'house-heart',
  'house-heart-fill': 'house-heart-fill',
  Family: 'house-heart',
  'Family-fill': 'house-heart-fill',
  image: 'image',
  'image-fill': 'image-fill',
  'image-landscape': 'image-landscape',
  'image-landscape-fill': 'image-landscape-fill',
  'image-portrait': 'image-portrait',
  'image-portrait-fill': 'image-portrait-fill',
  Picture: 'image',
  'Picture-fill': 'image-fill',
  'Info-circle': 'info-circle',
  'Info-circle-fill': 'info-circle-fill',
  'info-circle': 'info-circle',
  'info-circle-fill': 'info-circle-fill',
  'info-circle-small': 'info-circle-small',
  'info-circle-small-fill': 'info-circle-small-fill',
  'Info-circle-small': 'info-circle-small',
  'Info-circle-small-fill': 'info-circle-small-fill',
  'info-small': 'info-small',
  'info-small-fill': 'info-small',
  'Info-small': 'info-small',
  'Info-small-fill': 'info-small',
  info: 'info',
  'info-fill': 'info',
  Info: 'info',
  'Info-fill': 'info',
  'item-search': 'item-search',
  'item-search-fill': 'item-search',
  'keyboard-command': 'keyboard-command',
  'keyboard-command-fill': 'keyboard-command',
  'keyboard-esc': 'keyboard-esc',
  'keyboard-esc-fill': 'keyboard-esc',
  'keyboard-option-alt': 'keyboard-option-alt',
  'keyboard-option-alt-fill': 'keyboard-option-alt',
  'keyboard-return-enter': 'keyboard-return-enter',
  'keyboard-return-enter-fill': 'keyboard-return-enter',
  'keyboard-shift': 'keyboard-shift',
  'keyboard-shift-fill': 'keyboard-shift',
  'keyboard-spacebar': 'keyboard-spacebar',
  'keyboard-spacebar-fill': 'keyboard-spacebar',
  'keyboard-tab': 'keyboard-tab',
  'keyboard-tab-fill': 'keyboard-tab',
  Bulb: 'lamp',
  'Bulb-fill': 'lamp-fill',
  lamp: 'lamp',
  'lamp-fill': 'lamp-fill',
  'Bulb-small': 'lamp',
  'link-external-small': 'link-external-small',
  'link-external-small-fill': 'link-external-small',
  'External-link-small': 'link-external-small',
  'External-link-small-fill': 'link-external-small',
  'link-external': 'link-external',
  'link-external-fill': 'link-external',
  link: 'link',
  'link-fill': 'link',
  Link: 'link',
  'Link-fill': 'link',
  lock: 'lock',
  'lock-fill': 'lock-fill',
  Lock: 'lock',
  'Lock-fill': 'lock-fill',
  'lock-open': 'lock-open',
  'lock-open-fill': 'lock-open-fill',
  Unlock: 'lock-open',
  'Unlock-fill': 'lock-open-fill',
  'lock-password': 'lock-password',
  'lock-password-fill': 'lock-password-fill',
  Password: 'lock-password',
  'Password-fill': 'lock-password-fill',
  'loupe-zoom-plus': 'loupe-zoom-plus',
  'loupe-zoom-plus-fill': 'loupe-zoom-plus',
  'Zoom-in-alt': 'loupe-zoom-plus',
  'Zoom-in-alt-fill': 'loupe-zoom-plus',
  'loupe-zoom-minus': 'loupe-zoom-minus',
  'loupe-zoom-minus-fill': 'loupe-zoom-minus',
  'Zoom-out-alt': 'loupe-zoom-minus',
  'Zoom-out-alt-fill': 'loupe-zoom-minus',
  megaphone: 'megaphone',
  'megaphone-fill': 'megaphone-fill',
  Megaphone: 'megaphone',
  'Megaphone-fill': 'megaphone-fill',
  'menu-burger': 'menu-burger',
  'menu-burger-fill': 'menu-burger',
  Menu: 'menu-burger',
  'Menu-fill': 'menu-burger',
  'menu-dots-horizontal': 'menu-dots-horizontal',
  'menu-dots-horizontal-fill': 'menu-dots-horizontal',
  'menu-dots-vertical': 'menu-dots-vertical',
  'menu-dots-vertical-fill': 'menu-dots-vertical',
  'Elipsis-vertical': 'menu-dots-vertical',
  'Elipsis-vertical-fill': 'menu-dots-vertical',
  microphone: 'microphone',
  'microphone-fill': 'microphone-fill',
  Mic: 'microphone',
  'Mic-fill': 'microphone-fill',
  'microphone-mute': 'microphone-mute',
  'microphone-mute-fill': 'microphone-mute-fill',
  'minus-circle': 'minus-circle',
  'minus-circle-fill': 'minus-circle-fill',
  'Minus-circle': 'minus-circle',
  'Minus-circle-fill': 'minus-circle-fill',
  'minus-circle-small': 'minus-circle-small',
  'minus-circle-small-fill': 'minus-circle-small-fill',
  'Minus-circle-small': 'minus-circle-small',
  'Minus-circle-small-fill': 'minus-circle-small-fill',
  'minus-small': 'minus-small',
  'minus-small-fill': 'minus-small',
  'Minus-small': 'minus-small',
  'Minus-small-fill': 'minus-small',
  minus: 'minus',
  'minus-fill': 'minus',
  Minus: 'minus',
  'Minus-fill': 'minus',
  moon: 'moon',
  'moon-fill': 'moon-fill',
  'not-allowed': 'not-allowed',
  'not-allowed-fill': 'not-allowed',
  'Not-allowed': 'not-allowed',
  'Not-allowed-fill': 'not-allowed',
  'notebook-loupe': 'notebook-loupe',
  'notebook-loupe-fill': 'notebook-loupe-fill',
  'notebook-pen': 'notebook-pen',
  'notebook-pen-fill': 'notebook-pen-fill',
  Assignment: 'notebook-pen',
  'Assignment-fill': 'notebook-pen-fill',
  'password-cursor': 'password-cursor',
  'password-cursor-fill': 'password-cursor-fill',
  pen: 'pen',
  'pen-fill': 'pen-fill',
  Compose: 'pen',
  'Compose-fill': 'pen-fill',
  phone: 'phone',
  'phone-fill': 'phone-fill',
  Phone: 'phone',
  'Phone-fill': 'phone-fill',
  pin: 'pin',
  'pin-fill': 'pin-fill',
  'placeholder-circle': 'placeholder-circle',
  'placeholder-circle-fill': 'placeholder-circle',
  'Empty-circle': 'placeholder-circle',
  'Empty-circle-fill': 'placeholder-circle',
  'placeholder-square': 'placeholder-square',
  'placeholder-square-fill': 'placeholder-square',
  playlist: 'playlist',
  'playlist-fill': 'playlist-fill',
  Playlist: 'playlist',
  'Playlist-fill': 'playlist-fill',
  'plurall-symbol-small': 'plurall-symbol-small',
  'plurall-symbol-small-fill': 'plurall-symbol-small',
  'Plurall-Smile-x-small': 'plurall-symbol-small',
  'Plurall-Smile-x-small-fill': 'plurall-symbol-small',
  'plurall-symbol': 'plurall-symbol',
  'plurall-symbol-fill': 'plurall-symbol',
  'Plurall-Smile': 'plurall-symbol',
  'Plurall-Smile-fill': 'plurall-symbol',
  'plus-circle': 'plus-circle',
  'plus-circle-fill': 'plus-circle-fill',
  'Plus-circle': 'plus-circle',
  'Plus-circle-fill': 'plus-circle-fill',
  'plus-circle-small': 'plus-circle-small',
  'plus-circle-small-fill': 'plus-circle-small-fill',
  'Plus-circle-small': 'plus-circle-small',
  'Plus-circle-small-fill': 'plus-circle-small-fill',
  'plus-small': 'plus-small',
  'plus-small-fill': 'plus-small',
  'Plus-small': 'plus-small',
  'Plus-small-fill': 'plus-small',
  plus: 'plus',
  'plus-fill': 'plus',
  Plus: 'plus',
  'Plus-fill': 'plus',
  printer: 'printer',
  'printer-fill': 'printer-fill',
  Printer: 'printer',
  'Printer-fill': 'printer-fill',
  'question-circle': 'question-circle',
  'question-circle-fill': 'question-circle-fill',
  'Question-circle': 'question-circle',
  'Question-circle-fill': 'question-circle-fill',
  'Question-circle-big': 'question-circle',
  'Question-circle-big-fill': 'question-circle-fill',
  'question-circle-small': 'question-circle-small',
  'question-circle-small-fill': 'question-circle-small-fill',
  'Question-circle-small': 'question-circle-small',
  'Question-circle-small-fill': 'question-circle-small-fill',
  question: 'question',
  'question-fill': 'question',
  Question: 'question',
  'Question-fill': 'question',
  questions: 'questions',
  'questions-fill': 'questions-fill',
  Doubts: 'questions',
  'Doubts-fill': 'questions-fill',
  'quote-left-square': 'quote-left-square',
  'quote-left-square-fill': 'quote-left-square-fill',
  'Quote-left': 'quote-left-square',
  'Quote-left-fill': 'quote-left-square-fill',
  'quote-right-square': 'quote-right-square',
  'quote-right-square-fill': 'quote-right-square-fill',
  'Quote-right': 'quote-right-square',
  'Quote-right-fill': 'quote-right-square-fill',
  refresh: 'refresh',
  'refresh-fill': 'refresh',
  Reload: 'refresh',
  'Reload-fill': 'refresh',
  report: 'report',
  'report-fill': 'report-fill',
  robot: 'robot',
  'robot-fill': 'robot-fill',
  Robot: 'robot',
  'Robot-fill': 'robot-fill',
  'robot-smile': 'robot-smile',
  'robot-smile-fill': 'robot-smile-fill',
  'rows-large': 'rows-large',
  'rows-large-fill': 'rows-large-fill',
  'rows-medium': 'rows-medium',
  'rows-medium-fill': 'rows-medium-fill',
  'rows-small': 'rows-small',
  'rows-small-fill': 'rows-small-fill',
  'school-building': 'school-building',
  'school-building-fill': 'school-building-fill',
  'school-exam': 'school-exam',
  'school-exam-fill': 'school-exam-fill',
  'science-chemistry': 'science-chemistry',
  'science-chemistry-fill': 'science-chemistry-fill',
  Science: 'science-chemistry',
  'Science-fill': 'science-chemistry-fill',
  search: 'search',
  'search-fill': 'search',
  'Search-alt': 'search',
  'Search-alt-fill': 'search',
  send: 'send',
  'send-fill': 'send-fill',
  'Send-alt': 'send',
  'Send-alt-fill': 'send-fill',
  setting: 'setting',
  'setting-fill': 'setting-fill',
  'setting-gear': 'setting-gear',
  'setting-gear-fill': 'setting-gear-fill',
  Settings: 'setting-gear',
  'Settings-fill': 'setting-gear-fill',
  share: 'share',
  'share-fill': 'share-fill',
  'shopping-bag': 'shopping-bag',
  'shopping-bag-fill': 'shopping-bag-fill',
  Store: 'shopping-bag',
  'Store-fill': 'shopping-bag-fill',
  'sidebar-close': 'sidebar-close',
  'sidebar-close-fill': 'sidebar-close-fill',
  'Close-drawer': 'sidebar-close',
  'Close-drawer-fill': 'sidebar-close-fill',
  'sidebar-open': 'sidebar-open',
  'sidebar-open-fill': 'sidebar-open-fill',
  'Open-drawer': 'sidebar-open',
  'Open-drawer-fill': 'sidebar-open-fill',
  'sign-out': 'sign-out',
  'sign-out-fill': 'sign-out',
  'social-media-facebook': 'social-media-facebook',
  'social-media-facebook-fill': 'social-media-facebook',
  'social-media-instagram': 'social-media-instagram',
  'social-media-instagram-fill': 'social-media-instagram',
  'social-media-linkedin': 'social-media-linkedin',
  'social-media-linkedin-fill': 'social-media-linkedin',
  'social-media-tiktok': 'social-media-tiktok',
  'social-media-tiktok-fill': 'social-media-tiktok',
  'social-media-whatsapp': 'social-media-whatsapp',
  'social-media-whatsapp-fill': 'social-media-whatsapp',
  'social-media-x': 'social-media-x',
  'social-media-x-fill': 'social-media-x',
  'social-media-youtube': 'social-media-youtube',
  'social-media-youtube-fill': 'social-media-youtube',
  spinner: 'spinner',
  'spinner-fill': 'spinner',
  'Spinner-placeholder': 'spinner',
  'Spinner-placeholder-fill': 'spinner',
  'sport-volleyball': 'sport-volleyball',
  'sport-volleyball-fill': 'sport-volleyball-fill',
  'Sports-volleyball': 'sport-volleyball',
  'Sports-volleyball-fill': 'sport-volleyball-fill',
  star: 'star',
  'star-fill': 'star-fill',
  Star: 'star-fill',
  'Star-fill': 'star',
  'Star-empty': 'star',
  'Star-empty-fill': 'star-fill',
  'star-incomplete': 'star-incomplete',
  'star-incomplete-fill': 'star-incomplete',
  'Star-incomplete': 'star-incomplete',
  'Star-incomplete-fill': 'star-incomplete',
  'star-small': 'star-small',
  'star-small-fill': 'star-small-fill',
  'Star-empty-small': 'star-small',
  'Star-empty-small-fill': 'star-small-fill',
  'Star-small': 'star-small-fill',
  'Star-small-fill': 'star-small',
  'star-small-incomplete': 'star-small-incomplete',
  'star-small-incomplete-fill': 'star-small-incomplete',
  'Star-incomplete-small': 'star-small-incomplete',
  'Star-incomplete-small-fill': 'star-small-incomplete',
  stars: 'stars',
  'stars-fill': 'stars-fill',
  sun: 'sun',
  'sun-fill': 'sun-fill',
  "switch": 'switch',
  'switch-fill': 'switch',
  target: 'target',
  'target-fill': 'target-fill',
  teacher: 'teacher',
  'teacher-fill': 'teacher-fill',
  Teacher: 'teacher',
  'Teacher-fill': 'teacher-fill',
  'teacher-student': 'teacher-student',
  'teacher-student-fill': 'teacher-student-fill',
  'Teacher-Student': 'teacher-student',
  'Teacher-Student-fill': 'teacher-student-fill',
  'teacher-student-eye': 'teacher-student-eye',
  'teacher-student-eye-fill': 'teacher-student-eye-fill',
  telescope: 'telescope',
  'telescope-fill': 'telescope-fill',
  Telescope: 'telescope',
  'Telescope-fill': 'telescope-fill',
  'text-size': 'text-size',
  'text-size-fill': 'text-size',
  'Text-size': 'text-size',
  'Text-size-fill': 'text-size',
  'thumbs-down': 'thumbs-down',
  'thumbs-down-fill': 'thumbs-down-fill',
  'Thumbs-down': 'thumbs-down',
  'Thumbs-down-fill': 'thumbs-down-fill',
  'thumbs-up': 'thumbs-up',
  'thumbs-up-fill': 'thumbs-up-fill',
  'Thumbs-up': 'thumbs-up',
  'Thumbs-up-fill': 'thumbs-up-fill',
  thunder: 'thunder',
  'thunder-fill': 'thunder-fill',
  'tools-magic-pen': 'tools-magic-pen',
  'tools-magic-pen-fill': 'tools-magic-pen-fill',
  'tools-wench-ruler': 'tools-wench-ruler',
  'tools-wench-ruler-fill': 'tools-wench-ruler-fill',
  trashcan: 'trashcan',
  'trashcan-fill': 'trashcan-fill',
  Trashcan: 'trashcan',
  'Trashcan-fill': 'trashcan-fill',
  update: 'update',
  'update-fill': 'update',
  Update: 'update',
  'Update-fill': 'update',
  'upload-alt': 'upload-alt',
  'upload-alt-fill': 'upload-alt-fill',
  'upload-cloud': 'upload-cloud',
  'upload-cloud-fill': 'upload-cloud',
  upload: 'upload',
  'upload-fill': 'upload',
  Upload: 'upload',
  'Upload-fill': 'upload',
  'user-feedback': 'user-feedback',
  'user-feedback-fill': 'user-feedback-fill',
  'User-feedback': 'user-feedback',
  'User-feedback-fill': 'user-feedback-fill',
  'user-female-circle': 'user-female-circle',
  'user-female-circle-fill': 'user-female-circle-fill',
  'User-female-circle': 'user-female-circle',
  'User-female-circle-fill': 'user-female-circle-fill',
  'user-female': 'user-female',
  'user-female-fill': 'user-female-fill',
  'User-female': 'user-female',
  'User-female-fill': 'user-female-fill',
  'User-male-circle': 'user-male-circle',
  'User-male-circle-fill': 'user-male-circle-fill',
  'user-male-circle': 'user-male-circle',
  'user-male-circle-fill': 'user-male-circle-fill',
  'user-male': 'user-male',
  'user-male-fill': 'user-male-fill',
  'User-male': 'user-male',
  'User-male-fill': 'user-male-fill',
  'user-profile-add': 'user-profile-add',
  'user-profile-add-fill': 'user-profile-add-fill',
  'users-eye': 'users-eye',
  'users-eye-fill': 'users-eye-fill',
  users: 'users',
  'users-fill': 'users-fill',
  Users: 'users',
  'Users-fill': 'users-fill',
  'video-class-alt': 'video-class-alt',
  'video-class-alt-fill': 'video-class-alt-fill',
  'Video-class-alt': 'video-class-alt',
  'Video-class-alt-fill': 'video-class-alt-fill',
  'video-class': 'video-class',
  'video-class-fill': 'video-class-fill',
  'Video-class': 'video-class',
  'Video-class-fill': 'video-class-fill',
  video: 'video',
  'video-fill': 'video-fill',
  Video: 'video',
  'Video-fill': 'video-fill',
  'video-player': 'video-player',
  'video-player-fill': 'video-player-fill',
  'video-lesson': 'video-lesson',
  'video-lesson-fill': 'video-lesson-fill',
  'Video-lesson': 'video-lesson',
  'Video-lesson-fill': 'video-lesson-fill',
  volume: 'volume',
  'volume-fill': 'volume-fill',
  wallet: 'wallet',
  'wallet-fill': 'wallet-fill',
  Wallet: 'wallet',
  'Wallet-fill': 'wallet-fill',
  'warning-triangle': 'warning-triangle',
  'warning-triangle-fill': 'warning-triangle-fill',
  'Exclamation-circle': 'warning-triangle',
  'Exclamation-circle-fill': 'warning-triangle-fill',
  'warning-triangle-small': 'warning-triangle-small',
  'warning-triangle-small-fill': 'warning-triangle-small-fill',
  'Exclamation-circle-small': 'warning-triangle-small',
  'Exclamation-circle-small-fill': 'warning-triangle-small-fill',
  'warning-small': 'warning-small',
  'warning-small-fill': 'warning-small',
  'Exclamation-small': 'warning-small',
  'Exclamation-small-fill': 'warning-small',
  warning: 'warning',
  'warning-fill': 'warning',
  Exclamation: 'warning',
  'Exclamation-fill': 'warning',
  webcam: 'webcam',
  'webcam-fill': 'webcam-fill',
  Webcam: 'webcam',
  'Webcam-fill': 'webcam-fill'
};
export default iconList;